module.exports = require("./ja.js");